export const URI_REGEX = /^\w+\:/
export const testAttributes = {
    ANCHOR: 'link-anchor',
    LINK: 'link-gatsbylink'
}